import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const accountTransApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchAccountTrans: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-transaction`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body:data
                };
            },
            providesTags: ['accountTrans'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getAccountTransById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-translation-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['accountTransById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createAccountTrans: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/account-translation`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['accountTrans'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Account Translations");
            },
        }),
        updateAccountTrans: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/account-translation/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['accountTrans', 'accountTransById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","Account Translations")
            },
        }),

   
        deleteAccountTransById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/account-tran/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['accountTrans'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Account Translations");
            },
        }),

        exportAccountTransData: build.query({
            query: (query) => {
                return {
                    url: `/export/account-translation`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("accountTrans"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useGetAccountTransByIdQuery,
    useUpdateAccountTransMutation,
    useSearchAccountTransQuery,
    useLazyExportAccountTransDataQuery,
    useDeleteAccountTransByIdMutation,
    useCreateAccountTransMutation
} = accountTransApi;